import { Button, Dropdown, message } from 'antd';
import { Form, Formik } from 'formik';
import { useMemo } from 'react';

import { trackButtonClick } from '../../analytics/mixpanel';
import { DeleteDocIcon, EditDocIcon } from '../../assets';
import AngleUpSmallOutlined from '../../assets/common/AngleUpSmallOutlined';
import FolderExportOutlined from '../../assets/common/FolderExportOutlined';
import FolderOpenOutlined from '../../assets/common/FolderOpenOutlined';
import FolderPlusOutlined from '../../assets/common/FolderPlusOutlined';
import AngleRightOutlined from '../../assets/docchat/AngleRightOutlined';
import ClearBrushOutlined from '../../assets/docchat/ClearBrushOutlined';
import ThreeDotOutlined from '../../assets/docchat/ThreeDotOutlined';
import { acceptTypes } from '../../Constants';
import { DOCCHAT_MAX_FILES, LOADING } from '../../Constants/commonConstants';
import { stopPropagationFunc } from '../../utils/functions';
import CollectionListItem from './CollectionListItem';
// selectedCollection?.collection_id
const SavedComparisonsListItem = ({
  index,
  data,
  selectedCollection,
  selectedCollectionRef,
  selectedDoc,
  uploadStatus,
  handleDocumentClick,
  expandedCollections,
  handleCollection,
  addRef,
  validation,
  handleModal,
  handleUpload,
  records,
  handleClearChat,
  position,
  uuid,
}) => {
  const moveItems = useMemo(() => {
    return [
      {
        key: '1',
        label: 'Move to a new folder',
        icon: (
          <div className='flex'>
            <FolderPlusOutlined />
          </div>
        ),
        onClick: (e) => {
          stopPropagationFunc(e);
          handleModal('newFolder', data);
        },
      },
      ...(records?.map((item) =>
        item?.collection_id
          ? {
              key: item?.chat_id ?? item?.collection_id,
              label: item?.collection_name,
              icon: (
                <div className='flex'>
                  <FolderOpenOutlined size={14} />
                </div>
              ),
              onClick: (e) => {
                stopPropagationFunc(e);
                handleModal('moveToFolder', {
                  ...data,
                  collectionId: item?.collection_id,
                });
                // handleExport();
              },
            }
          : null
      ) ?? []),
    ];
  }, [records]);

  const items = [
    {
      key: 'edit',
      label: `Rename ${data?.collection_id ? 'folder' : 'file'}`,
      icon: <EditDocIcon />,
      onClick: (e) => {
        stopPropagationFunc(e);
        handleModal('edit', data);
      },
    },
    data?.collection_id
      ? null
      : {
          key: 'move',
          label: (
            <div className='flex align-center' style={{ justifyContent: 'space-between' }}>
              <div className='flex align-center' style={{ gap: '8px' }}>
                <FolderExportOutlined />
                <span>Move</span>
              </div>
              <AngleRightOutlined />
            </div>
          ),
          // onClick: (e) => {
          //   stopPropagationFunc(e);
          // },
          children: moveItems,
          popupClassName: 'move-sub-menu-popup',
        },

    {
      key: 'clear',
      label: 'Clear Chat',
      icon: <ClearBrushOutlined />,
      onClick: (e) => {
        stopPropagationFunc(e);
        handleClearChat(data);
      },
    },
    {
      key: 'delete',
      label: `Delete ${data?.collection_id ? 'folder' : 'file'}`,
      icon: <DeleteDocIcon />,
      onClick: (e) => {
        stopPropagationFunc(e);
        handleModal('delete', data);
      },
    },
  ];
  const isSelectedCollection =
    selectedCollection?.collection_id && selectedCollection?.collection_id === data?.collection_id;
  return (
    <li
      ref={
        isSelectedCollection || selectedDoc?.document_id === data?.document_id
          ? selectedCollectionRef
          : null
      }
      className={`${
        (selectedCollection?.collection_id &&
          selectedCollection?.collection_id === data?.collection_id &&
          'selected-collection') ||
        (selectedDoc?.document_id &&
          selectedDoc?.document_id === data?.document_id &&
          'selected-tab')
      }`}
      key={data?.chat_id}
    >
      <div
        className={`list-item ${data?.collection_id ? 'collection' : ''}`}
        onClick={() => {
          handleDocumentClick({ ...data });
        }}
      >
        {/* Document Information */}
        <div className='info-container'>
          <div className='flex align-center' style={{ gap: '4px' }}>
            {data?.collection_id && <FolderOpenOutlined />}
            <div className='doc-name ellipsis' role='button'>
              {data.document_name || data?.collection_name || `Untitled Folder ${index + 1}`}
            </div>
          </div>
          <span className='fs-10 color-n8'>
            {new Date(data?.created_time || data?.chat_start_time)
              .toLocaleString('en-In', {
                dateStyle: 'long',
                timeZone: 'Asia/Kolkata',
              })
              ?.replace(',', '')
              ?.replace(' at', ',')}
          </span>
        </div>
        {/* Action Buttons */}
        {uploadStatus !== LOADING && (
          <div
            className={
              isSelectedCollection ||
              (selectedDoc?.document_id && selectedDoc?.document_id === data.document_id) ||
              (selectedDoc?.collection_id && selectedDoc?.collection_id === data.collection_id)
                ? 'actions-active'
                : 'actions'
            }
          >
            {data?.collection_id && (
              <div
                onClick={(e) =>
                  handleCollection({
                    e,
                    collectionId: data?.collection_id,
                  })
                }
                className={`angle-btn ${
                  expandedCollections?.has(data?.collection_id) ? '' : 'reversed'
                }`}
              >
                <AngleUpSmallOutlined />
              </div>
            )}
            <Dropdown
              menu={{ items }}
              trigger={['click']}
              overlayClassName='file-menu-dropdown'
              destroyOnHidden
            >
              <button className='action-btn list-more-button' onClick={(e) => e.stopPropagation()}>
                <ThreeDotOutlined />
              </button>
            </Dropdown>
          </div>
        )}
      </div>
      {data?.collection_id && expandedCollections.has(data?.collection_id) && (
        <section className='collection-list-section'>
          <ul className='mt-8'>
            {data?.documents?.map((childItem, j) => (
              <CollectionListItem
                key={childItem?.document_id}
                index={j}
                collectionData={data}
                data={childItem}
                selectedDoc={selectedDoc}
                uploadStatus={uploadStatus}
                handleDocumentClick={handleDocumentClick}
                handleModal={handleModal}
                records={records}
                handleClearChat={handleClearChat}
                active={uuid === data.collection_id && position === j}
              />
            ))}
          </ul>
          {DOCCHAT_MAX_FILES - data?.documents?.length > 0 && (
            <Formik
              initialValues={{ file: null }}
              validate={(values) =>
                validation({
                  values,
                  noLeft: DOCCHAT_MAX_FILES - data?.documents?.length,
                })
              }
            >
              {({ setFieldValue }) => (
                <Form className='form'>
                  <input
                    type='file'
                    name='file'
                    onChange={(event) => {
                      const files = Array.from(event.target.files);
                      setFieldValue('file', files);
                      // Clear previous validation error if new files are selected
                      const validationErrors = validation({
                        values: {
                          file: files,
                        },
                        noLeft: DOCCHAT_MAX_FILES - data?.documents?.length,
                      });

                      // Only trigger the upload if no validation errors exist
                      if (Object.keys(validationErrors).length === 0) {
                        handleUpload({
                          file: files,
                          collection_id: data?.collection_id,
                          noLeft: DOCCHAT_MAX_FILES - data?.documents?.length,
                        });
                      }

                      // If there are errors, don't proceed with upload
                      if (Object.keys(validationErrors).length > 0) {
                        setFieldValue('file', '');
                        message.error(validationErrors?.file);
                      }
                    }}
                    hidden
                    ref={addRef}
                    multiple
                    accept={acceptTypes}
                  />
                  <div style={{ padding: '8px' }}>
                    <Button
                      className='add-list-item fs-12 color-primary fw-600'
                      variant='dashed'
                      color='primary'
                      onClick={() => {
                        trackButtonClick({
                          type: 'Document Upload Docchat',
                        });
                        addRef.current.click();
                      }}
                    >
                      Upload Document ({DOCCHAT_MAX_FILES - data?.documents?.length} more)
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </section>
      )}
    </li>
  );
};

export default SavedComparisonsListItem;
